export default "__VITE_ASSET__ioH0QZ7y__"